import apiClient from "@/libs/axios";

export const state = {
    data: [],
    total: {
        totalItems: 5,
        totalPages: 5,
    }
};

export const mutations = {
    setData: (state, data) => {
        state.data = data.result.data;
        state.total = {
            totalItems: data.total,
            totalPages: data.last_page,
        };
    },

    updateData: (state, data) => {
        let temp = state.data;
        state.data = temp.map((item) => item.id === data.id ? {...item, vendor: {...item.vendor, is_active: data.vendor.is_active}} : item)
    },

    deleteItem: (state, id) => {
        let data = state.data;
        state.data = data.filter((item) => item.id !== id)
    },
};

export const actions = {



    async vendorRatings({ commit }, data) {
        await apiClient
            .get(`api/v1/ratings?filter[vendor_id]=${data.id}`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setData', response.data);
                }
            })
            .catch(error => {
                throw error;
            },);
    }
};

export const getters = {
    getData(state) {
        return state.data;
    },
    getTotal(state) {
        return state.total;
    },
};
